/**
 * Resolves the effective balance type for a published-shift booking.
 *
 * Resolution order:
 *   1. Shift-unit `balanceType` override — explicit null means "no balance effect"
 *   2. Shift-level `balanceType` default
 *   3. `null` — no balance effect
 *
 * A unit-level `null` intentionally overrides a shift-level non-null value.
 * Use `undefined` (not `null`) on the unit to express "no override set".
 */
export function resolveEffectiveBalanceType(shift: { balanceType?: string | null }, unit: { balanceType?: string | null }): string | null {
  if (unit.balanceType !== undefined) {
    return unit.balanceType;
  }
  return shift.balanceType ?? null;
}
